import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import Layout from '../../shared/components/layouts/MainLayout';
import OpportunitiesTable from '../components/OpportunitiesTable';
import SearchInput from '../../shared/components/forms/SearchInput';
import {fetchOpportunities, nextPage, previousPage} from '../actions'
import {debounce} from 'lodash-es'
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  PageName,
  PageViewName,
  TrackEventName
} from '../../shared/constants/SegmentEvents';
import {PHILIPPINE_REGIONS} from '../../../utils/philippineRegions'
import isEmpty from "is-empty";
import SearchSummary from '../components/SearchSummary';
import AlertFrequencyModal from '../components/AlertFrequencyModal';
import { openModal } from "../../shared/actions";
import {showNotification} from "../../../utils/toast";
import Multiselect from 'multiselect-react-dropdown';
import CurrencyInput from 'react-currency-input-field';

const multiSelectLabelCss = {
  width: "100%",
  marginBottom: "8px"
}

const multiSelectCss = {
  chips: {
    color: "#fff",
    background: "#5761F0",
    width: "max-content",
  },
  searchBox: {
    maxWidth: "100%",
    backgroundColor: "#fff",
    border: "solid #8082a9",
    borderRadius: "6px",
    width: "100%",
    marginTop: "2px",
    marginBottom: "4px",
    fontSize: "0.95em",
    fontFamily: "'Lota Grotesque Regular',sans-serif",
    letterSpacing: "-0.028em",
    padding: "12px"
  }
}

const pagesToSkip = 4;

export class ProjectFinder extends Component {
  constructor(props){
    super(props)
    this.state = {
      keyword: "",
      regions: [],
      min_amount: "",
      max_amount: "",
      sort_params: {sort_key: "", sort_direction: "DESC"},
      loading: false,
      error: {},
      errorText: "",
      showSearchSummary: false
    }

    this.handleChange = this.handleChange.bind(this);
    this.filterOpportunities = debounce(this.filterOpportunities.bind(this), 500);
    this.handlePageClick = debounce(this.handlePageClick.bind(this), 300);
    this.handleFastRewindClick = debounce(this.handleFastRewindClick.bind(this), 300);
    this.handlePreviousButtonClick = debounce(this.handlePreviousButtonClick.bind(this), 300);
    this.handleNextButtonClick = debounce(this.handleNextButtonClick.bind(this), 300);
    this.handleFastForwardClick = debounce(this.handleFastForwardClick.bind(this), 300);
    this.handleSort = debounce(this.handleSort.bind(this), 300);
    this.applyFilters = this.applyFilters.bind(this);
    this.renderSearchSummary = this.renderSearchSummary.bind(this);
    this.openModal = this.openModal.bind(this);
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentWillMount() {
    const params = new URLSearchParams(this.props.location.search);
    const keyword = params.get('keyword');
    const min_amount = params.get('min_amount');
    const max_amount = params.get('max_amount');
    const regions = params.get('regions') ? params.get('regions').split(',') : [];
    this.setState({keyword: keyword, min_amount: min_amount, max_amount: max_amount, regions: regions, showSearchSummary: true});
    this.filterOpportunities();
  }

  componentDidMount() {
    const {user} = this.props;

    if (user.id) {
      segmentEventTracker.identify(user.id);
    }

    segmentEventTracker.setContext({page_name: PageName.PROJECT_FINDER});
    segmentEventTracker.trackPageView(PageViewName.PROJECT_FINDER_VIEWED);

    this.showUnsubscribeNotif();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.opportunities !== this.props.opportunities) {
      this.setState({loading: false});
    }
  }

  showUnsubscribeNotif() {
    const currentUrl = new URL(window.location.href);

    if (isEmpty(currentUrl.search)) { return; }

    const searchParams = new URLSearchParams(currentUrl.search);
    const unsubscribe = searchParams.get("unsubscribe");
    const keyword = searchParams.get("filters[keyword]");
    const regions = searchParams.get("filters[regions]");
    let notifMessage = "";

    if (!isEmpty(keyword) && !isEmpty(regions)) {
      notifMessage = ` for '${keyword}' in ${regions}.`;
    } else if (!isEmpty(keyword)) {
      notifMessage = ` for '${keyword}'.`;
    } else if (!isEmpty(regions)) {
      notifMessage = ` in ${regions}.`;
    } else {
      notifMessage = "."
    }

    if (unsubscribe === "true") {
      showNotification("success", `Successfully unsubscribed. You will no longer receive alerts${notifMessage}`);
    }
  }

  async filterOpportunities(page=1) {
    const params = new URLSearchParams(this.props.location.search);
    const new_bids_only = params.get('new_bids_only')

    const filter_hash = {
      keyword: this.state.keyword,
      regions: this.state.regions,
      min_amount: this.state.min_amount,
      max_amount: this.state.max_amount,
      new_bids_only: new_bids_only,
    }

    await this.props.fetchOpportunities(
      filter_hash,
      this.state.sort_params,
      page,
    )
  }

  handleChange(event) {
    this.setState({
      keyword: event.target.value,
      showSearchSummary: false,
    });
  };

  handlePageClick(value) {
    this.setState({loading: true});
    this.filterOpportunities(value);
  }

  handleFastRewindClick() {
    const {opportunitiesCurrentPage } = this.props;

    if (opportunitiesCurrentPage === undefined) {
      this.setState({loading: true});
      this.filterOpportunities(1);
      return;
    }

    const page = (opportunitiesCurrentPage > pagesToSkip) ?
      Number(opportunitiesCurrentPage) - pagesToSkip :
      Number(opportunitiesCurrentPage) - (Number(opportunitiesCurrentPage) - 1);

    this.setState({loading: true});
    this.filterOpportunities(page);
  }

  handlePreviousButtonClick() {
    const page = Number(this.props.opportunitiesCurrentPage) - 1;
    this.setState({loading: true});
    this.filterOpportunities(page);
  }

  handleNextButtonClick() {
    const page = Number(this.props.opportunitiesCurrentPage) + 1;
    this.setState({loading: true});
    this.filterOpportunities(page);
  }

  handleFastForwardClick() {
    const {opportunitiesCurrentPage, opportunitiesTotalPages } = this.props;

    if (opportunitiesCurrentPage === undefined || opportunitiesTotalPages === undefined) {
      this.setState({loading: true});
      this.filterOpportunities(1);
      return;
    }

    const page = ((opportunitiesTotalPages - opportunitiesCurrentPage) > pagesToSkip) ?
      Number(opportunitiesCurrentPage) + pagesToSkip :
      Number(opportunitiesCurrentPage) + (Number(opportunitiesTotalPages) - Number(opportunitiesCurrentPage));

    this.setState({loading: true});
    this.filterOpportunities(page);
  }

  applyFilters() {
    const {keyword, regions, min_amount, max_amount} = this.state;

    if (!isEmpty(min_amount) && !isEmpty(max_amount)) {
      if (parseFloat(min_amount) > parseFloat(max_amount)) {
        this.setState({errorText: "Minimum amount cannot be greater than Maximum Amount"})
        return
      }
    }

    this.setState({errorText: "", loading: true, showSearchSummary: true})

    const payload = {
      keyword: keyword,
      regions: regions,
      min_amount: min_amount,
      max_amount: max_amount
    }

    segmentEventTracker.trackEvent(TrackEventName.PROJECT_FILTER_APPLIED, payload);
    this.filterOpportunities();
  }

  handleAmountKeypress(event) {
    if (["-", "e"].includes(event.key)) {
      event.preventDefault()
    }
  }

  handleSort(key) {
    const {sort_key, sort_direction} = this.state.sort_params;
    let new_direction = sort_direction;

    if (key === sort_key) {
      new_direction = sort_direction === "ASC" ? "DESC" : "ASC"
    }

    this.setState({
      loading: true,
      sort_params: {
        sort_key: key,
        sort_direction: new_direction
      }
    })

    this.filterOpportunities();
  }

  openModal() {
    this.props.openModal('projectAlertsModal');

    const {keyword, regions, min_amount, max_amount} = this.state;

    const payload = {
      keyword: keyword,
      regions: regions,
      min_amount: min_amount,
      max_amount: max_amount
    }

    segmentEventTracker.trackEvent(TrackEventName.PROJECT_FINDER_ALERT_MODAL_OPENED, payload);
  }

  renderError() {
    if (!isEmpty(this.state.errorText)) {
      return (
        <section data-test="error-section" className="cardSection ds-notice -danger">
          <p className="copy">{this.state.errorText}</p>
        </section>
      );
    }
  }

  renderSearchSummary() {
    const {
      showSearchSummary,
      keyword,
      min_amount,
      max_amount,
      regions
    } = this.state;

    const isFilterEmpty = isEmpty(keyword) && isEmpty(regions) && isEmpty(min_amount) && isEmpty(max_amount)

    if (showSearchSummary && !isFilterEmpty) {
      return (
        <SearchSummary
          totalCount={this.props.opportunitiesTotalCount}
          keyword={keyword}
          regions={regions}
          minAmount={min_amount}
          maxAmount={max_amount}
          onClick={() => this.openModal()}
        />
      )
    }
  }

  multiSelectOnChange(selectedList) {
    this.setState({regions: selectedList, showSearchSummary: false});
  }

  handleSearchInputEnter(event) {
    if (event.key === "Enter") {
      this.applyFilters()
    }
  }

  render(){
    const {
      opportunities,
      opportunitiesCurrentPage,
      opportunitiesTotalPages,
      opportunitiesTotalCount,
    } = this.props;

    return(
      <Fragment>
        <AlertFrequencyModal
          keyword={this.state.keyword}
          regions={this.state.regions}
          min_amount={this.state.min_amount}
          max_amount={this.state.max_amount}
        />
        <Layout gridClassName='_marginTop--xxlarge-tabletUp --gigaWide'>
        {this.renderError()}
          <div className='_padding--small filter-container'>
            <h1 className="title">Discover new government projects for your business with Project Finder!</h1>
            <SearchInput
              name="search"
              value={this.state.keyword || ''}
              onClickButton={this.applyFilters}
              onKeyDown={event => this.handleSearchInputEnter(event)}
              onChange={event => this.handleChange(event)}
              placeholder="e.g. 'Web', 'Construction', 'Computer', ..."
            />
            <div className="ds-formGroup">
            <div class='ds-input'>
              <span>Minimum Amount</span>
                <CurrencyInput
                  prefix={"₱"}
                  value={this.state.min_amount}
                  name="min_amount"
                  placeholder="₱50,000.00"
                  step={50000}
                  allowDecimals={true}
                  decimalScale={2}
                  allowNegativeValue={false}
                  onValueChange={(value, _name) => this.setState({min_amount: value, showSearchSummary: false})}
                  onKeyPress={event => this.handleAmountKeypress(event)}
                />
              </div>
              <div class='ds-input'>
              <span>Maximum Amount</span>
                <CurrencyInput
                  prefix={"₱"}
                  value={this.state.max_amount}
                  name="min_amount"
                  placeholder="₱100,000.00"
                  step={50000}
                  allowDecimals={true}
                  decimalScale={2}
                  allowNegativeValue={false}
                  onValueChange={(value, _name) => this.setState({max_amount: value, showSearchSummary: false})}
                  onKeyPress={event => this.handleAmountKeypress(event)}
                />
              </div>
            </div>
            <div className="ds-formGroup">
              <label style={multiSelectLabelCss}>
                <div>
                  <span>Regions</span>
                </div>
                <Multiselect
                  isObject={false}
                  options={PHILIPPINE_REGIONS}
                  selectedValues={this.state.regions}
                  onSelect={this.multiSelectOnChange}
                  onRemove={this.multiSelectOnChange}
                  placeholder="Select Regions"
                  avoidHighlightFirstOption={true}
                  style={multiSelectCss}
                />
              </label>
            </div>
          </div>
          {this.renderSearchSummary()}
          <OpportunitiesTable
            loading = {this.state.loading}
            opportunities={opportunities}
            sort_params={this.state.sort_params}
            totalPages={opportunitiesTotalPages}
            totalCount={opportunitiesTotalCount}
            currentPage={opportunitiesCurrentPage}
            handleSort={this.handleSort}
            handlePageClick={this.handlePageClick}
            handleFastRewindClick={this.handleFastRewindClick}
            handlePreviousButtonClick={this.handlePreviousButtonClick}
            handleNextButtonClick={this.handleNextButtonClick}
            handleFastForwardClick={this.handleFastForwardClick}
          />
        </Layout>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    opportunities: state.opportunities,
    opportunitiesCurrentPage: state.opportunitiesCurrentPage,
    opportunitiesTotalPages: state.opportunitiesTotalPages,
    opportunitiesTotalCount: state.opportunitiesTotalCount,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchOpportunities: (filter_hash, sort_params, page) => dispatch(fetchOpportunities(filter_hash, sort_params, page)),
    nextPage: page => dispatch(nextPage(page)),
    previousPage: page => dispatch(previousPage(page)),
    openModal: () => dispatch(openModal('projectAlertsModal'))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectFinder);



// WEBPACK FOOTER //
// ./src/features/projectFinder/containers/ProjectFinder.js